module.exports = __webpack_public_path__ + "img/hr-garballo-08.7a5a3cd5.png";